const getAvailableMonitors = require('./available-monitors');
const { getParams } = require('./params');

async function log(data) {
  const monitors = getAvailableMonitors();
  const { clear } = data;
  const processedData = getParams(data, clear);

  if (!processedData) return;

  await Promise.all(monitors.map(monitor => monitor.log(processedData)));
}

module.exports = log;
